import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import TimeHorizontalScroll from './TimeHorizontalScroll';
import moment from 'moment';


class AvailabilityTimeSlots extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    onCardClick(selectedIndex, date) {
        this.props.onDateSelect(date.day, date.year, true, date.reqDate);
        this.setState({ selectedIndex });
    }

    renderCruiseDates() {
        let { selectedDate = '', selectedCategory, cruiseDates = [] } = this.props;
        let { selectedIndex } = this.state;

        let rows = (
            <>
                {cruiseDates.map((date, i) => (
                    <li key={date.day} className="col col-md-4 col-xs-4 col-sm-1 availability-data-card-li">
                        <button
                            className={`filter-benefits-button align-center availability-date-card  datecard-hover title-hover  ${
                                selectedDate === date.day
                                    ? selectedCategory === 'Relaxation Areas'
                                        ? 'selected-thermal-card'
                                        : 'selected-day-card'
                                    : ''
                                }`}
                            aria-expanded={selectedDate === date.day}
                            data-test-id="date-card"
                            onClick={this.onCardClick.bind(this, i, date)}>
                            <p aria-label={moment(date.reqDate).format('dddd MMMM Do')} className="filter-button-text  font-size-p5 gotham-xn-medium line-height-25">
                                {date.day}
                            </p>
                            <p className="filter-button-text font-size-p2 gotham-xn-medium line-height-25 new-line">
                                {date.location}
                            </p>
                        </button>
                        <span className='span-arrow'></span>
                        <Collapse
                            in={
                                selectedIndex === i &&
                                selectedDate &&
                                selectedCategory !== 'Relaxation Areas'
                            }>
                            <div className="availability-collapse-container headline-gray-e6-bg">
                                <TimeHorizontalScroll
                                    selectedTimeSlot={this.props.selectedTimeSlot}
                                    onTimeSlotSelect={this.props.onTimeSlotSelect}
                                    displayNavButtons={true}
                                    timeSlots={this.props.timeSlots}></TimeHorizontalScroll>
                            </div>
                        </Collapse>
                    </li>
                ))}
            </>
        )

        return (
            <fieldset>
                <legend className="visuallyhidden">Choose a Date and Time</legend>
                <ul className='availability-dates-row row list-style'>
                    {rows}
                </ul>
            </fieldset>);

    }


    render() {

        return (
            <div >
                {this.renderCruiseDates()}
            </div>
        );
    }
}



export default AvailabilityTimeSlots;